import {
  formatMoney as sharedFormatMoney,
  getExchangeRateFormatter as sharedGetExchangeRateFormatter,
  getNumberFormatter as sharedGetNumberFormatter,
  getPercentageFormatter as sharedGetPercentageFormatter
} from "shared/utils/formatter";

export { formatUrl } from "shared/utils/formatter";

interface FormatMoneyOptions {
  value: number
  currency: server.dto.Currencies | undefined
  displayCents: boolean
}

// These bind the shared, locale parameterized formatters to the current UI locale.
export const formatMoney = (options: FormatMoneyOptions) =>
  sharedFormatMoney({ ...options, locale: serverReference.culture.uiLocale });

export const getExchangeRateFormatter = () =>
  sharedGetExchangeRateFormatter(serverReference.culture.uiLocale);

export const getPercentageFormatter = (decimalDigits: number) =>
  sharedGetPercentageFormatter(serverReference.culture.uiLocale, decimalDigits);

export const getNumberFormatter = () =>
  sharedGetNumberFormatter(serverReference.culture.uiLocale);
